import { Component, ChangeDetectionStrategy, Type } from '@angular/core';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';

interface CheckboxProps extends FormlyFieldProps { }

export interface FormlyCheckboxFieldConfig
  extends FormlyFieldConfig<CheckboxProps> {
  type: 'checkbox' | Type<FormlyFieldCheckbox>;
}

@Component({
  selector: 'formly-field-primeng-checkbox',
  template: `
    <div class="p-field-checkbox flex items-center gap-x-2">
      <p-checkbox
        [inputId]="field.key?.toString()"
        [binary]="true"
        [formControl]="formControl"
        [formlyAttributes]="field"
        (onChange)="props.change && props.change(field, $event)"
      >
      </p-checkbox>
      <label [for]="field.key" class="cursor-pointer pit-1" [innerHTML]="props.label"></label>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldCheckbox extends FieldType<
  FieldTypeConfig<CheckboxProps>
> {
// override defaultOptions = {
//   props: {
//     hideLabel: true,
//   },
// };
}
